import React from 'react';
import PropTypes from 'prop-types';

import OrderDetailsShipmentEventInfo from '../../orders/orderDetails/shipmentView/OrderDetailsShipmentEventInfo';
import OrderDetailsShipmentProduct from '../../orders/orderDetails/shipmentView/OrderDetailsShipmentProduct';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { FIELD_NA } from '../../orders/constants';

export const OrderShipmentsPF = ({ orderDetailsData }) => {
  const { shippingInformation, productDetails, currencyCode } = orderDetailsData;
  return shippingInformation && shippingInformation.length > 0 ? (
    <div className='orderDetails__shipments'>
      {shippingInformation.map((info, i) => {
        const {
          deliveryNotes: {
            carrierName,
            outboundCartonCount,
            shipmentDetails: {
              actualShippingDate,
              estimatedDeliveryDate,
              shipFromPlantName,
              carrierTrackingNumber,
              billOfLadingNumber
            },
            outboundTransportationTypeCode,
            carrierUrlAddress,
            packs
          },
          productDetails: shipmentProductDetails
        } = info;
        const products = shipmentProductDetails
          ? Object.keys(shipmentProductDetails).map(productCode => ({
              ...productDetails[productCode],
              shipmentProductDetails: shipmentProductDetails[productCode],
              currencyCode: currencyCode
            }))
          : [];
        return (
          <div className='mb5-sm'>
            <OrderDetailsShipmentEventInfo
              shipmentNumber={i + 1}
              shipmentsTotal={shippingInformation.length}
              cartonsTotal={outboundCartonCount < 1 ? 1 : outboundCartonCount}
              carrierUrlAddress={carrierUrlAddress}
              trackingNumber={carrierTrackingNumber || FIELD_NA}
              dateShipped={actualShippingDate}
              estimatedDeliveryDate={estimatedDeliveryDate}
              carrier={carrierName || FIELD_NA}
              shippingMethod={outboundTransportationTypeCode || FIELD_NA}
              shippingOrigin={shipFromPlantName || FIELD_NA}
              billOfLadingNumber={billOfLadingNumber || FIELD_NA}
            />
            {packs.map((pack, i) => {
              const trackingNumber = pack.parcelTrackingNumber || FIELD_NA;
              return (
                <div>
                  <div style={{ paddingLeft: '20px', paddingBottom: '20px' }}>
                    <h2 style={{ fontWeight: 'bold' }}>
                      <TranslatedCopy id='orderstatus.cartonCurrent' values={{ current: i + 1, total: packs.length }} />
                    </h2>
                    <h2 style={{ fontWeight: 'bold' }}>
                      <TranslatedCopy id='orderstatus.trackingNumber' />
                      {': '}
                      {trackingNumber}
                    </h2>
                  </div>
                  <div>
                    <div style={{ paddingLeft: '20px' }}>
                      {pack.packageDetail.map(detail => {
                        let size;
                        const detailProduct = products.filter(
                          product =>
                            product.shipmentProductDetails.filter(shipmentDetail => {
                              if (shipmentDetail.deliveryScheduleLineNumber === detail.deliveryScheduleLineNumber) {
                                size = shipmentDetail.sizeDescription;
                                return true;
                              }
                              return false;
                            }).length > 0
                        )[0];

                        return (
                          <OrderDetailsShipmentProduct
                            product={detailProduct}
                            shipped={detail.shippedQuantity}
                            size={size}
                            full
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  ) : null;
};

OrderShipmentsPF.propTypes = {
  orderDetailsData: PropTypes.object
};

OrderShipmentsPF.defaultProps = {
  orderDetailsData: null
};

export default OrderShipmentsPF;
